import { EntitiesStore } from "./entities-store.abstract";
import { HttpClient } from "@angular/common/http";
import { CountryDependencyEntityStore } from './country-dependency-entity-store';
import { Injector } from '@angular/core';


/**
 * The medals number of an athlete in WCupAthlete medals.
 *
 * @export
 * @interface IWCupAthleteMedals
 */
export interface IWCupAthleteMedals {
  Golds: number;
  Silvers: number;
  Bronzes: number;
}

/**
 * The events that belongs to a WCup Athlete event.
 *
 * @export
 * @interface IWCupAthleteEvents
 */
export interface IWCupAthleteEvents {
  Individual: string[];
  Team: string[];
  Mixed: string[];
}

/**
 * The AthleteIndividual Rank for a certain stage on WCup Athlete.
 *
 * @export
 * @interface IWCupAthleteIndividual
 */
export interface IWCupAthleteIndividual {
  Rnk: number;
  CatId: number;
  CatCode: string;
  Outcome: string;
}

/**
 * The detail of WCup Athlete Event.
 *
 * @export
 * @interface IWCupAthleteDetail
 */
export interface IWCupAthleteDetail {
  ID: number;
  Year: number;
  Place: string;
  Events: IWCupAthleteEvents;
  Individual: IWCupAthleteIndividual[];
  Team: any;
  Mixed: any;
}

/**
 * The base item of WCupAthlete returned.
 *
 * @export
 * @interface IWCupAthleteItem
 */
export interface IWCupAthleteItem {
  SubLevelId: number;
  SubLevelName: string;
  Caps: number;
  Podiums: number;
  Medals: IWCupAthleteMedals;
  Details: IWCupAthleteDetail[];
}

/**
 * Storage for WCupAthlete (https://api.worldarchery.org/v3/API/AthleteWCups).
 *
 * @export
 * @class WorldRankingStore
 * @extends {EntitiesStore<IWCupAthleteItem>}
 */
export class AthleteWCupPageStore extends EntitiesStore<IWCupAthleteItem>{
  constructor(http: HttpClient, injector:Injector) {
    super('ATHLETEWCUPS', http, [{entity: new CountryDependencyEntityStore(http, injector)}]);
  }
}
